import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchProductDetails, updateProduct } from "../../redux/slices/productSlice";
import axios from "axios";

const EditProductPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { selectedProduct, loading, error } = useSelector((state) => state.products);

    const [productData, setProductData] = useState({
        name: "",
        description: "",
        price: 0,
        countInStock: 0,
        sku: "",
        category: "",
        brand: "",
        sizes: [],
        colors: [],
        collection: "",
        material: "",
        gender: "",
        images: [],
    });



    const [upLoading, setUploading] = useState(false) // Image Uploading state

    useEffect(() => {
        if (id) {
            dispatch(fetchProductDetails(id));
        }
    }, [dispatch, id]);

    useEffect(() => {
        if (selectedProduct) {
            setProductData(selectedProduct);
        }
    }, [selectedProduct]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setProductData((prevData) => ({ ...prevData, [name]: value }));
    };


    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("image", file);

        try {
            setUploading(true);
            const { data } = await axios.post(
                `${import.meta.env.VITE_BACKEND_URL}/api/upload`, formData,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );
            setProductData((prevData) => ({
                ...prevData,
                images: [...prevData.images, { url: data.imageUrl, altText: "" }],
            }))
            setUploading(false)
        } catch (error) {
            console.error(error);
            setUploading(false)
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(updateProduct({ id, productData })).then(() => {
            navigate("/admin/products");
        });
    }

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;


    return (
        <div className="max-w-5xl mx-auto p-6 shadow-md rounded-md">
            <h2 className="text-3xl font-bold mb-6">Edit Product</h2>
            <form
                onSubmit={handleSubmit}
            >
                {/* Name */}
                <div className="mb-6">
                    <label className="block font-semibold mb-2">Product Name</label>
                    <input
                        type="text"
                        name="name"
                        placeholder="product name"
                        value={productData.name}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md p-2"
                        required />
                </div>
                {/* Brand */}
                <div className="mb-6">
                    <label className="block font-semibold mb-2">Brand</label>
                    <input
                        type="text"
                        name="brand"
                        placeholder="Brand name"
                        value={productData.brand}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md p-2"
                        required />
                </div>
                {/* Category */}
                <div className="mb-6">
                    <label className="block font-semibold mb-2">Category</label>
                    <input
                        type="text"
                        name="category"
                        placeholder="Top wear, Bottom Wear"
                        value={productData.category}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md p-2"
                        required />
                </div>

                {/* Gender */}
                <div className="mb-6">
                    <label className="block font-semibold mb-2">Gender</label>
                    <input
                        type="text"
                        name="gender"
                        placeholder="Male, Female, Unisex"
                        value={productData.gender}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md p-2"
                        required />
                </div>
                {/* Material */}
                <div className="mb-6">
                    <label className="block font-semibold mb-2">Material</label>
                    <input
                        type="text"
                        name="material"
                        placeholder="Cotton, Denim, ,Wool, Polyester, Silk"
                        value={productData.material}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md p-2"
                        required />
                </div>
                {/* Description */}
                <div className="mb-6">
                    <label className="block font-semibold mb-2">Description</label>
                    <textarea
                        onChange={handleChange}
                        name="description"
                        placeholder="product description"
                        value={productData.description}
                        className="w-full border border-gray-300 rounded-md p-2"
                        rows={4}
                        required />
                </div>

                {/* Price  */}
                <div className="mb-6">
                    <label className="block font-semibold mb-2" >Price</label>
                    <input
                        type="number"
                        name="price"
                        placeholder="0"
                        value={productData.price}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md p-2" />
                </div>

                {/* Count In Stock  */}
                <div className="mb-6">
                    <label className="block font-semibold mb-2" >Count In Stock</label>
                    <input
                        type="number"
                        name="countInStock"
                        placeholder="0"
                        value={productData.countInStock}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md p-2" />
                </div>

                {/* SKU  */}
                <div className="mb-6">
                    <label
                        className="block font-semibold mb-2" >
                        SKU
                    </label>
                    <input
                        type="text"
                        name="sku"
                        placeholder="SKU"
                        value={productData.sku}
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-md p-2" />
                </div>

                {/* Sizes  */}
                <div className="mb-6">
                    <label
                        className="block font-semibold mb-2" >
                        Sizes (comma-separated)

                    </label>
                    <input
                        type="text"
                        name="sizes"
                        placeholder="S, M, L, XL"
                        value={productData.sizes.join(", ")}
                        onChange={(e) => setProductData({ ...productData, sizes: e.target.value.split(",").map((size) => size.trim()) }
                        )}
                        className="w-full border border-gray-300 rounded-md p-2" />
                </div>

                {/* Colors  */}
                <div className="mb-6">
                    <label
                        className="block font-semibold mb-2" >
                        Colors
                    </label>
                    <input
                        type="text"
                        placeholder="Enter colors"
                        value={productData.colors.join(", ")}
                        onChange={(e) => setProductData({ ...productData, colors: e.target.value.split(",").map((color) => color.trim()) }
                        )}

                        className="w-full border border-gray-300 rounded-md p-2" />

                </div>



                {/* Image Upload */}
                <div className="mb-6">
                    <label className="block font-semibold mb-2">Upload Image</label>
                    <input type="file"
                        onChange={handleImageUpload}
                    />
                    {upLoading && <p>Uploading Image...</p>}
                    <div className="flex gap-4 mt-4">
                        {productData.images.map((image, index) => (
                            <div
                                key={index}
                                className="">
                                <img
                                    src={image.url}
                                    alt={image.altText || "Product Image"} className="w-20 h-20 object-cover rounded-md shadow-md" />
                            </div>
                        ))}
                    </div>
                </div>
                <button type="submit" className="w-full bg-green-500 text-white py-2 rounded-md hover:bg-green-600 transition-colors">Update Product</button>
            </form>
        </div>
    )
}

export default EditProductPage